<template>
	 <div>
		<v-row class="pa-2">
			<v-col cols="12" sm="8">
				<v-card-actions class="rounded-xl var mx-5 mb-2">
					<v-card-title>Reporte Categorías</v-card-title>
				</v-card-actions>
				<v-select clearable :items="Localidades" filled v-model="localidad" label="Sucursal"/>
				<v-text-field clearable filled v-model="start" type="date" label="Fecha inicial"/>
				<v-text-field clearable filled v-model="end"  type="date" label="Fecha final"/>
				<v-select clearable filled :items="valoresUnicosInnerPack" v-model="Cat1"  type="date" label="Categoría 1 (InnerPack)"/>
				<v-select clearable filled :items="familias" v-model="familia"  type="date" label="Categoría 2 (Familia)"/>
				<v-select clearable filled :items="Proveedores" v-model="proveedor" type="date" label="Categoría 3 (Proveedor)"/>
				<v-btn :loading="loading" block x-large dark @click="BuscarVentasPorFiltros()" color="black"> Buscar </v-btn>
			</v-col>
			<v-col cols="12" sm="4">    
				<p style="font-size:35px"> Unidades Vendidas {{Total}}</p>
			</v-col>
		</v-row>
        
        <template class="pa-3">
            <v-snackbar
                    v-model="snackbar" top vertical="" :timeout="5000"
                    >
                    {{ Mensaje }}
                    <v-btn
                    color="info"
                    text
                    @click="snackbar = false"
                    >
                    Cerrar
                    </v-btn>
            </v-snackbar>
        </template>
    </div>
	
</template>


<script>
import axios from 'axios';
  export default {
    name: 'ReporteMinimos',
    data() {
    return {
        TipoCedula: '',
        detalles: [],
		Localidades: [],
		search:'',
		loading:true,
		localidad:'',
		end: null,
		start: null,
		loading:true,
        codigoProducto: null,  // Puedes inicializar con null o algún valor por defecto
        proveedor: null,       // Si no tienes un valor inicial, null es una buena opción
        familia: null,         // De la misma manera, puedes inicializar con null
		familias:[],
		Cat1:null,
		fechaInicial: null,
		fechaFinal: null,
		Proveedores:[],
		Total: 0,
		};
	},
	created () {
		this.selectProveedores();
		this.selectFamilia();
		this.listarAsociadas();
		this.obtenerValoresUnicosInnerPack();
		this.BuscarVentasPorFiltros();
    },
    methods: {
		async obtenerValoresUnicosInnerPack() {
    	let me = this;
			me.localidad = this.$store.state.usuario.localidad;
			let header = { "Authorization": "Bearer " }; // Asegúrate de añadir el token correcto.
			let configuracion = { headers: header };
			
			await axios.get('api/Productos/ValoresUnicosInnerPack', { 
				params: { localidad: me.localidad }, 
				headers: configuracion.headers 
			})
			.then(function(response) {
				// Aquí manejas la respuesta, por ejemplo, asignándola a una variable de tu componente.
				me.valoresUnicosInnerPack = response.data;
			})
			.catch(function(error) {
				// Aquí manejas los errores, como una alerta al usuario.
				alert("Error obteniendo valores únicos de InnerPack: " + error);
			});
		},

		async listarAsociadas(){
			var items = [];
			let me=this;
			me.Localidades.push(me.$store.state.usuario.localidad);
			this.localidad = this.$store.state.usuario.localidad;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
				items=response.data;
				items.map(function(x){
					me.Localidades.push(x.localdiadAsociada);
				});
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
		},
		selectFamilia(){
			let me=this;
			this.familias = [];
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
			var familiasArray=[];
			axios.get('api/Familias/Select/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
				familiasArray=response.data;
				familiasArray.map(function(x){
					me.familias.push(x.nombre);
				});
			}).catch(function(error){
				console.log(error);
			});
		},
		selectProveedores(){
				let me=this;
				let header={"Authorization" : "Bearer " };
				let configuracion= {headers : header};
				var proveedoresArray=[];
				axios.get('api/proveedores/Select/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
					proveedoresArray=response.data;
					proveedoresArray.map(function(x){
						me.Proveedores.push(x.proveedor);
					});
				}).catch(function(error){
					console.log(error);
				});
		},
		Reiniciar(){
			this.proveedor = null;
			this.familia = null;
			this.BuscarVentasPorFiltros();
		},
		BuscarVentasPorFiltros() {
			this.loading = true;
            const header = { "Authorization": "Bearer " /* Aquí deberías poner tu token de autenticación */ };
            const configuracion = { headers: header };
            
            // Parámetros para la consulta
            const params = {
                localidad: this.localidad,
                categoria: this.Cat1,
                familia: this.familia,
                proveedor: this.proveedor,
                fechaInicial: this.start,
                fechaFinal: this.end
            };

            axios.get('api/Productos/ReporteVentasPorFiltros', {
                params: params,
                headers: configuracion.headers
            })
            .then(response => {
                this.Total = response.data;
				this.loading = false;
            })
            .catch(error => {
                alert("Problema obteniendo el reporte de ventas. Por favor, envíe una foto de este problema a su equipo de soporte. Error: " + error);
            })
            .finally(() => {
                this.loading = false;
            });
        }


    },
  }
</script>
